module.exports = "<div id=\"success-container\" class=\"row\">\n    <div class=\"col-xs-2\" style=\"padding-left: 0;\">\n        <i id=\"success-icon\" class=\"fa fa-check-circle\" aria-hidden=\"true\"></i>\n    </div>\n    <div class=\"col-xs-9\" style=\"padding-left: 0;\">\n        <h2 id=\"success-title\" *ngIf=\"title\">{{ title }}</h2>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/shared/success-page/success.template.html
// module id = 1275
// module chunks = 0